import { Text } from '@fluentui/react/lib/Text';
import { PrimaryButton, Icon, IComboBoxOption, DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from '@fluentui/react';

import TimeTaxSupportSystemClient from '../../../../system';
import MessageCourier from '../../../../lib/MessageCourier';
import { t } from 'i18next';
import { DateTime } from 'luxon';
import { User } from '../../../../system/User';
import { LiquidacionAsincronaV2 } from '../../../../system/liquidacion_asincrona/LiquidacionAsincronaV2System';
import { BillableDistributionTemplateItem, SolicitudExportacionReporteAsincrona } from '../../../../system/report_hours_settlement/ReportHoursSettlementSystem';
import { useState } from 'react';
import DialogConfirmGenerateReport from '../components/DialogConfirmGenerateReport';

interface IGenerateSettlement {
  setButtonDisability?: any;
  system: TimeTaxSupportSystemClient;
  billableDistributionTemplate: BillableDistributionTemplateItem[];
  courier: MessageCourier;
  generatedSettlementResponse: SolicitudExportacionReporteAsincrona | undefined;
  generateSettlement: () => void;
  settlementType: IComboBoxOption;
  from: DateTime;
  period: string;
  user: User;
}

const columns: IColumn[] = [
  {
    key: 'empresa',
    name: 'Empresa',
    minWidth: 150,
    onRender: (item: BillableDistributionTemplateItem) => item.empresa.label,
  },
  {
    key: 'area',
    name: 'Área',
    minWidth: 150,
    onRender: (item: BillableDistributionTemplateItem) => item.area.label,
  },
  {
    key: 'empresaDestino',
    name: 'Empresa destino',
    minWidth: 180,
    onRender: (item: BillableDistributionTemplateItem) => item.empresaDestino.label,
  },
];

const GenerateReportHoursSettlement = (props: IGenerateSettlement) => {
  const [showGenerateDialog, setShowGenerateDialog] = useState(false);

  return (
    <div className="ms-Grid mt-2" dir="ltr">
      <div className="ms-Grid-row">
        {/* Información */}
        <div className="ms-Grid-col ms-sm12 ms-md4">
          <div className="mt-1">
            <Text>
              <Icon iconName="PublicCalendar" /> {t('Período a liquidar:')} {props.period}
            </Text>
          </div>

          <div className="mt-2">
            <Text>
              <Icon iconName="TableComputed" /> {t('Tipo de liquidación:')} {props.settlementType.text}
            </Text>
          </div>

          <div className="mt-2">
            <Text>
              <Icon iconName="Clock" /> {t('Fecha de inicio del proceso:')} {props.from.toFormat('dd/MM/yyyy hh:mm:ss a')}
            </Text>
          </div>

          <div className="mt-2">
            <Text>
              <Icon iconName="ReminderPerson" /> {t('Generado por:')} {props.user.getCollaborator().fullName()}
            </Text>
          </div>
        </div>

        {/* Tabla */}
        <div className="ms-Grid-col ms-sm12 ms-md6">
          {props.billableDistributionTemplate.length > 0 ? (
            <>
              <Text variant="large" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <Icon iconName="Table" /> {t('Derivación de costos')}
              </Text>
              <DetailsList
                items={props.billableDistributionTemplate}
                columns={columns}
                selectionMode={SelectionMode.none}
                layoutMode={DetailsListLayoutMode.justified}
                compact
              />
            </>
          ) : (
            <div
              style={{
                border: '1px solid #edebe9',
                padding: '24px 16px',
                textAlign: 'center',
                color: '#605e5c',
                background: '#faf9f8',
              }}
            >
              <Icon iconName="Info" style={{ fontSize: 20, marginBottom: 8 }} />
              <div style={{ fontWeight: 600 }}>{t('No se configuró una derivación de costos.')}</div>
              <div style={{ marginTop: 4 }}>{t('La liquidación se generará sin aplicar una derivación de costos.')}</div>
            </div>
          )}
        </div>
      </div>

      {!props.generatedSettlementResponse && (
        <div className="mt-4">
          <PrimaryButton text={t('Generar Reporte')} onClick={() => setShowGenerateDialog(true)} />
        </div>
      )}

      <DialogConfirmGenerateReport
        isOpen={showGenerateDialog}
        onCancel={() => setShowGenerateDialog(false)}
        onConfirm={() => {
          setShowGenerateDialog(false);
          props.generateSettlement();
        }}
      />
    </div>
  );
};

export default GenerateReportHoursSettlement;
